import { Avatar, Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';

const JobsNotification = () => {
    const dispatch = useDispatch();
    const sessionUserId = sessionStorage.getItem("userId");

    const { getUnreadJobNotifications } = useSelector(state => state?.getUnreadJobNotifications);

    useEffect(() => {
        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUnreadJobNotifications/${sessionUserId}`,
            };
            await dispatch(actions.GETUNREADJOBNOTIFICATIONS(data1));
        };
        fetchData();
    }, [dispatch, sessionUserId]);

    const getColorByType = (type) => {
        switch (type) {
            case 'job_post':
                return 'black'; // Green
            case 'connection_request':
                return 'black'; // Red
            default:
                return 'black'; // Blue
        }
    };

    const formatTime = (timestamp) => {
    if (!timestamp) return '';
    
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
    });

    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
    });

    return `${formattedDate} at ${formattedTime}`;
};


    const handleSelectNotiFication = async (datas) => {
            const data = {
                data: {
                },
                method: "put",
                apiName: `markNotificationAsReadForUser/${datas.notification_id}`,
            };
            const response1 = await dispatch(actions.MARKNOTIFICATIONASREADFORUSER(data));
    
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUnreadJobNotifications/${sessionUserId}`,
            };
            await dispatch(actions.GETUNREADJOBNOTIFICATIONS(data1));
    
            const data3 = {
                    data: {},
                    method: "get",
                    apiName: `getNotificationCategoryCounts/${sessionUserId}`,
                };
                const response = await dispatch(actions.GETNOTIFICATIONCATEGORYCOUNTS(data3));
    
        }

    return (
        <Box>
            {getUnreadJobNotifications?.data?.length > 0 ? (
                getUnreadJobNotifications?.data?.map((data) => (
                    <Box
                        key={data.notification_id}
                        sx={{
                            position: "relative",
                            mt: 2,
                            p: 2,
                            borderRadius: 2,
                            border: "1px solid #e0e0e0",
                            backgroundColor: "#fafafa",
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                        }}
                        onClick={() => handleSelectNotiFication(data)}
                    >
                        {/* Notification Badge */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: 5,
                                right: 8,
                                backgroundColor: "#f44336",
                                color: "white",
                                borderRadius: "50%",
                                width: 18,
                                height: 18,
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                            }}
                        >
                            !
                        </Box>

                        {/* Avatar */}
                        <Avatar src={data.image_url} />

                        {/* Content */}
                        <Box flex={1}>
                            {/* Title */}
                            <Typography variant="subtitle2" sx={{ color: getColorByType(data.type), fontWeight: 'bold' }}>
                                {data.title}
                            </Typography>

                            {/* Message */}
                            <Typography  sx={{ mt: 0.5,color: '#000000' }}>
                                {data.message}
                            </Typography>

                            {/* Timestamp */}
                            <Typography variant="caption" sx={{ color: '#999', mt: 0.5 }}>
                                {formatTime(data.createdAt)}
                            </Typography>
                        </Box>
                    </Box>
                ))
            ) : (
                <>
                    <Typography variant='h6'>No new job notifications</Typography>
                    <Typography>
                        When your connections post a job, it will show up here.
                    </Typography>
                </>
            )}
        </Box>
    );
};

export default JobsNotification;
